// import React, { Fragment } from 'react';
// import { ListboxOption, ListboxOptions, Transition } from '@headlessui/react';
import React from 'react';
import { ListboxOption, ListboxOptions } from '@headlessui/react';
import type { SnapSelectMenuOptionType } from '.';
import { EmptyState } from './EmptyState';
import { ColorSwatch } from './ColorSwatch';
import { classNames } from '../../util/classNames';

type Props = {
  selectOptions: SnapSelectMenuOptionType[];
  open: boolean;
  loading: boolean;
};

export const DesktopMenu: React.FC<Props> = (props) => {
  // const { selectOptions, open, loading } = props;
  const { selectOptions, loading } = props;
  return (
    // <Transition
    //   show={open}
    //   as={Fragment}
    //   leave='transition ease-in duration-100'
    //   leaveFrom='opacity-100'
    //   leaveTo='opacity-0'
    // >
    <ListboxOptions className='desktop:block absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none tablet:text-sm'>
      {selectOptions.length > 0 ? (
        selectOptions.map((option) =>
          option.type === 'header' ? (
            <ListboxOption
              aria-readonly
              value={option.value}
              className='px-4 py-2 bg-gray-200 w-full font-semibold'
              key={option.value}
            >
              {option.name}
            </ListboxOption>
          ) : (
            <ListboxOption
              key={option.id}
              className={() =>
                classNames(
                  option.selected ? 'bg-blue-100' : '',
                  option.color ? 'flex' : '',
                  'relative cursor-default select-none py-2 my-1 pl-3 pr-9 hover:bg-blue-200 active:bg-blue-200',
                )
              }
              value={option}
            >
              {option.color ? <ColorSwatch color={option.color} /> : null}
              <span className={'block truncate'}>{option.name}</span>
            </ListboxOption>
          ),
        )
      ) : (
        <EmptyState loading={loading} />
      )}
    </ListboxOptions>
    // </Transition>
  );
};
